import NotFound from "@spectrum-icons/illustrations/NotFound"
import {
  Button,
  Content,
  Heading,
  IllustratedMessage,
  View,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { Navigate } from "react-router"

export function ErrorPage() {
  function goHome() {
    return <Navigate to={"/dashboard"} />
  }

  return (
    <View height="100vh">
      <IllustratedMessage>
        <NotFound />
        <Heading>Error 404 </Heading>
        <Content>Page Not Found</Content>
        <Button
          margin="5rem"
          variant="accent"
          onPress={goHome}
          href="/dashboard"
        >
          Go to Dashboard
        </Button>
      </IllustratedMessage>
    </View>
  )
}
